<template>
  <article class="article-card">
    <div class="content">
      <div>
        <p class="t-h5 title" v-html="article.title" />
        <div
          class="description t-p-m-160"
          v-html="nbsp(extractFirstParagraph(article.lead))"
        />
      </div>
      <div class="wrapper">
        <span v-if="article.publication_date" class="date t-p-s-130">{{
          formatDate(article.publication_date, 'D.MM.YYYY')
        }}</span>
        <BaseButton
          :to="articleLink(article)"
          :tag="NuxtLink"
          color="secondary"
          :text="t('read-more')"
          class="button"
        />
      </div>
    </div>
    <BaseImage :image="article.image" class="image" />
  </article>
</template>

<script lang="ts" setup>
import { NuxtLink } from '#components'
import type { PublicArticle } from '@/service/__generated-api'

defineProps<{
  article: PublicArticle
}>()

const { t } = useI18n()
const localePath = useLocalePath()
const articleLink = ({ slug }: PublicArticle): string =>
  localePath({ name: 'blog-slug', params: { slug } })
</script>
<style lang="scss" scoped>
.article-card {
  @include flex-col;
  overflow: hidden;
  background-color: $layout-background-02;
  border-radius: $border-radius;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: rem(12px);
  margin-top: auto;
  border-top: 1px solid $layout-divider;
}

.content {
  @include flex-col;
  flex: 1;
  order: 2;
  padding: rem(22px) rem(20px);

  @include media-up(md) {
    padding-inline: rem(24px);
  }
}

.image {
  order: 1;
  height: rem(256px);
}

.title {
  margin-bottom: rem(8px);
}

.description {
  @include line-clamp(3);
  min-height: rem(54px);
  margin-bottom: rem(24px);
  color: $layout-text-02;
}

.date {
  color: $layout-text-03;
}
</style>
